import styled from 'styled-components';
import { ShrinkContentColumn } from '../ShrinkContent';

const DetailsSection = styled(({ children, className }) => {
  return (
    <ShrinkContentColumn className={className}>{children}</ShrinkContentColumn>
  );
})`
  h3 {
    margin: var(--cell-padding);
  }
`;

export default DetailsSection;
